import React, { Component, Fragment } from 'react';
import {
  Row, Col, Table, Input, Button, ButtonGroup
} from "reactstrap";
import { api, constant, uiHelper } from "../helpers";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { ProductPartTypeahead } from "../components";
import classnames from "classnames";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Alert from "react-s-alert";

let focusedRowIndex = null;
let startingIndex = 0;
let defaultPrefix = "row";
let lastTabIndexActive = false;
const getWarehouseAreas = () =>
  api
    .fetch("Warehouse/WarehouseAreas")
    .then(response => {
      return {
        wareHouseAreaList:
          _.map(
            response.data,
            item => {
              item.value = item.id;
              item.label = item.name;
              return item;
            })
      };
    })
    .catch(x => console.error(x));

const formatCountList = (list) => {
  return _.map(list, (item, index) => {
    item.transferDate = item.transferDate ? moment(item.transferDate).toDate() : null;
    item.expirationDate = item.expirationDate ? moment(item.expirationDate).toDate() : null;
    item.partQuantity = item.partQuantity === null ? "" : item.partQuantity;
    item.productQuantity = item.productQuantity === null ? "" : item.productQuantity;
    item.content = item.isProductContent
      ? { label: item.productSku, value: item.productId, description: item.description, isProductContent: item.isProductContent, unitOfMeasurement: item.unitOfMeasurement }
      : { label: item.partNumber, value: item.partId, description: item.description, isProductContent: item.isProductContent, unitOfMeasurement: item.unitOfMeasurement };
    item.pristine = item;
    return item;
  });
};

const setFocus = (index) => {
  const element = document.getElementById(`${defaultPrefix}-${index}`);
  if (element && element.id) {
    element.focus();
    element.autofocus = true;
  }
}
export default class InventoryCycleCount extends Component {
  static displayName = InventoryCycleCount.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      wareHouseAreaList: [],
      wareHouseArea: null,
      currentBayNumber: null,
      currentBinNumber: null,
      pagedList: null,
      selectedDate: null,
      itemToEdit: null,
      datePickerFocused: false,
      typeaheadFocused: false,
      selectedIndex: null,
      currentTabIndex: null,
      collapseInstructions: true,
    }
    this.itemRefs = [];
    this.datePickerRef = [];
    this.onDismiss = this.onDismiss.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.onBayChange = this.onBayChange.bind(this);
    this.resolveKeyPress = this.resolveKeyPress.bind(this);
    this.moveDownRow = this.moveDownRow.bind(this);
    this.moveUpRow = this.moveUpRow.bind(this);
    this.onTab = this.onTab.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onTypeAheadChange = this.onTypeAheadChange.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.onSave = this.onSave.bind(this);
    this.setOnclickFocus = this.setOnclickFocus.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.resolveKeyPress, false);
    window.addEventListener("scroll", this.onScroll);

    Promise.all([getWarehouseAreas()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus);
    });
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.resolveKeyPress, false);
    window.removeEventListener("scroll", this.onScroll);
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null
    });
  }

  resolveKeyPress(event) {
    if (event.key === constant.TabKey) {
      this.onTab(event);
    }
    if (event.key === constant.ArrowDownKey || event.keyCode === 40) {
      this.moveDownRow();
    }
    if (event.key === constant.ArrowUpKey || event.keyCode === 38) {
      this.moveUpRow();
    }
  }

  refreshList(wareHouseId, index) {
    api.post(`Warehouse/CycleCountsByWarehouseArea/${wareHouseId}`)
      .then(response => {
        if (response.data) {
          let formatList = formatCountList(response.data);
          const indexToUse = index !== undefined ? index : startingIndex;
          this.setState({
            pagedList: {
              ...this.state.pagedList,
              list: formatList
            },
            selectedIndex: indexToUse,
          }, () => {
            focusedRowIndex = indexToUse;
            if (index !== undefined) {
              this.itemRefs[indexToUse].scrollIntoView();
            }
          });
        }
      })
  }

  onSelectWarehouseAreaChange(selection) {
    this.setState({
      wareHouseArea: selection,
      currentBayNumber: 1,
      currentBinNumber: 1
    }, () => { this.refreshList(selection.value) })
  }

  onBayChange(currentBayNumber, moveForward) {
    let newBayNumber = null;
    if (moveForward) {
      if (currentBayNumber === this.state.wareHouseArea.numberOfBays) return;
      newBayNumber = currentBayNumber + 1;
    } else {
      if (currentBayNumber === 1) return;
      newBayNumber = currentBayNumber - 1;
    }
    let list = this.state.pagedList.list.slice();
    var index = _.findIndex(list, i => { return i.bay === newBayNumber && i.bin === 1; })
    focusedRowIndex = index;
    this.itemRefs[index].scrollIntoView();
    setFocus(index)
    this.setState({
      currentBayNumber: newBayNumber,
      selectedIndex: index,
    });
  }

  moveDownRow() {
    let list = this.state.pagedList.list.slice();
    const lastIndex = list.length - 1;
    if (this.state.selectedIndex === lastIndex || this.state.selectedIndex === null || this.state.typeaheadFocused) return;
    focusedRowIndex = this.state.selectedIndex + 1;
    if (this.state.selectedIndexEdited) {
      this.onSave(this.state.selectedIndex, true)
    } else {
      setFocus(this.state.selectedIndex + 1);
      this.setState({
        selectedIndex: this.state.selectedIndex + 1,
        selectedIndexEdited: false
      });
    }
  }

  moveUpRow() {
    if (this.state.selectedIndex === startingIndex || this.state.selectedIndex === null || this.state.typeaheadFocused) return;
    focusedRowIndex = this.state.selectedIndex - 1;
    if (this.state.selectedIndexEdited) {
      this.onSave(this.state.selectedIndex, true)
    } else {
      setFocus(focusedRowIndex);
      this.setState({
        selectedIndex: focusedRowIndex,
        selectedIndexEdited: false
      });
    }
  }

  onTab(event) {
    if (lastTabIndexActive) {
      this.moveDownRow();
      lastTabIndexActive = false
    }
  }

  addNewRow(itemIndex) {
    this.addNewRow.didrun = true; //adds property to function
      let newPagedList = Object.assign({}, this.state.pagedList);
      let listCopy = newPagedList.list.slice();
      let itemToCopy = listCopy[itemIndex];
    if (itemToCopy.content === null || !itemToCopy.content.value) {
      this.addNewRow.didrun = false;
      return;
    }
      const newItem = {
        id: 0,
        bay: itemToCopy.bay,
        bin: itemToCopy.bin,
        content: null,
        description: "",
        lotNumber: "",
        poNumber: "",
        partNumber: "",
        partId: null,
        productId: null,
        productQuantity: null,
        productSku: "",
        partQuantity: null,
        unitOfMeasurement: "",
        warehouseBinId: itemToCopy.warehouseBinId,
        wareHouseAreaId: itemToCopy.warehouseAreaId,
        isProductContent: false,
        enteredByUserName: "",
        expirationDate: null,
        transferDate: null,
        isNew: true
      };
      focusedRowIndex = itemIndex + 1
      listCopy.splice(itemIndex + 1, 0, newItem);
      newPagedList.list = listCopy;
      setFocus(focusedRowIndex);
      this.setState({
        selectedIndex: focusedRowIndex,
        pagedList: newPagedList,
        selectedIndexEdited: false
      }, () => {
          this.addNewRow.didrun = false;
      });
  }

  onInputChange(input, index, fieldName) {
    let list = this.state.pagedList.list.slice();
    list[index][fieldName] = input.target.value;
    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      selectedIndexEdited: true
    });
  }

  onSelectChange(selection, index, fieldName) {
    let list = this.state.pagedList.list.slice();
    list[index][fieldName] = selection.value
      ? selection : selection.target.value;
    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      selectedIndexEdited: true
    })
  }

  onDateChange(selectedDate, index, fieldName) {
    let list = this.state.pagedList.list.slice();
    list[index][fieldName] = selectedDate;
    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      selectedIndexEdited: true
    });
  }

  onTypeAheadChange(selection, index) {
    let list = this.state.pagedList.list.slice();
    list[index].content = selection;
    list[index].description = selection.description;
    list[index].unitOfMeasurement = selection.unitOfMeasurement;
    list[index].isProductContent = selection.isProduct;
    list[index].productSku = selection.isProductContent ? selection.label : null;
    list[index].partNumber = selection.isProductContent ? null : selection.label;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      selectedIndexEdited: true
    })
  }

  isFormValid(item) {
    let warnings = [];
    if (item.content === null || !item.content || item.content.label === "") {
      warnings.push("Please enter a product or part");
    }
    if ((!item.isProductContent && (item.partQuantity === null || item.partQuantity === "")) ||
      (item.isProductContent && (item.productQuantity === null || item.productQuantity === ""))) {
      warnings.push(`Please enter quantity for ${item.isProductContent ? item.productSku : item.partNumber} in Bin: ${item.bin}`);
    }

    if (warnings.length) {
      Alert.error(warnings.join(", "))
    }
    return warnings.length === 0;
  }

  onSave(indexToUpdate, fromMoveFunc) {
    let list = this.state.pagedList.list.slice();
    const index = (indexToUpdate || this.state.selectedIndex);
    focusedRowIndex = fromMoveFunc ? focusedRowIndex : index + 1;
    let item = Object.assign({}, list[index]);
    if (item.content.label === "" || item.content.label === null) {
      setFocus(focusedRowIndex);
      list[index] = item.pristine;
      this.setState({
        pagedList: { ...this.state.pagedList, list: list },
        selectedIndex: focusedRowIndex,
        datePickerFocused: false,
        selectedIndexEdited: false
      })
    } else {
      if (!this.isFormValid(item)) return;
      let payload = {
        Bay: parseInt(item.bay, 10),
        Bin: parseInt(item.bin, 10),
        WarehouseAreaId: parseInt(this.state.wareHouseArea.value, 10),
        WarehouseBinId: item.WarehouseBinId !== null ? parseInt(item.WarehouseBinId, 10) : null,
        PartId: item.isProductContent ? null : parseInt(item.content.value, 10),
        ProductId: item.isProductContent ? parseInt(item.content.value, 10) : null,
        ProductQuantity: item.isProductContent ? parseInt(item.productQuantity, 10) : null,
        PartQuantity: item.isProductContent ? null : parseFloat(item.partQuantity),
        TransferDate: item.transferDate,
        ExpirationDate: item.expirationDate,
        LotNumber: item.lotNumber,
        PoNumber: item.poNumber
      }
      api.post("Warehouse/SaveInventoryCycleCount", payload)
        .then(response => {
          if (response.data) {
            if (response.data.partQuantity === null && response.data.productQuantity === null) {
              let additionalExistingBayBin = _.find(list, i => { return i.bay === item.bay && i.bin === item.bin && !_.isEqual(i, item) });
              if (additionalExistingBayBin === undefined) {
                list[index] = response.data;
                list[index].content = {label: "", value: null};
                list[index].bay = item.bay;
                list[index].bin = item.bin;
                list[index].pristine = Object.assign(list[index]);
              } else {
                list.splice(index, 1);
              }
                            
              Alert.success("Count was removed"); 
              focusedRowIndex = index;

            } else {
              Alert.success("Count was saved"); 
              list[index].id = response.data.id;
              list[index].pristine = Object.assign(list[index]);
            }
            setFocus(focusedRowIndex);

            this.setState({
              datePickerFocused: false,
              selectedIndex: focusedRowIndex,
              selectedIndexEdited: false,
              pagedList: { ...this.state.pagedList, list: list }
            });
          }

        }).catch(error =>
          Alert.error(`There was an error saving count`)
        );
    }
  }

  setOnclickFocus(index) {
    if (this.addNewRow.didrun) return;
    if (index === this.state.selectedIndex) return;
    focusedRowIndex = index;
    setFocus(focusedRowIndex);
      this.setState({
        selectedIndex: index
      });
  }

  removeFocus() {
    document.activeElement.blur();
  }
  resolveTabEvent(index) {
    lastTabIndexActive = true;
  }
  render() {
    const {
      wareHouseAreaList,
      wareHouseArea,
      currentBayNumber,
      selectedIndex,
      collapseInstructions
    } = this.state;
    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2"><Col><h4 className="">Inventory Cycle Count</h4></Col></Row>
        <Row className="mt-2">
          <Col xs="2" className="boldText">Select an Area/Row:
            <Select
              closeMenuOnSelect={true}
              id="warehouseId"
              onMenuClose={() => this.removeFocus()}
              isMulti={false}
              value={wareHouseArea}
              options={wareHouseAreaList}
              onChange={(e) => this.onSelectWarehouseAreaChange(e)}
            />
          </Col>
          <Col>
            <div>
              <FontAwesomeIcon className="cbdmdBlueText" size="1x" icon="info-circle" title={collapseInstructions ? "Click to hide instructions" : "Click to view instructions"} onClick={() => this.setState({ collapseInstructions: !collapseInstructions })} />
              {collapseInstructions ? uiHelper.inventoryCycleCountInstructions() : null}
            </div>
          </Col>
          {wareHouseArea &&
            <Col xs="2" className="float-right">
              <div className="cbdmdBlueText fontSize24 float-right p-2">
                <Row>
                  {currentBayNumber !== 1 &&
                    <Col xs="1"><span onClick={() => this.onBayChange(currentBayNumber, false)}><FontAwesomeIcon icon="step-backward" title="Back" /></span></Col>
                  }
                  <Col><span className="">BAY: {currentBayNumber}</span></Col>
                  {currentBayNumber !== wareHouseArea.numberOfBays &&
                    <Col xs="1"><span onClick={() => this.onBayChange(currentBayNumber, true)}><FontAwesomeIcon icon="step-forward" title="Next" /></span></Col>
                  }
                </Row>
              </div>
            </Col>
          }
        </Row>
        {wareHouseArea !== null &&
          <Row className="mt-2">
            <Col>
              <Table className="tablePaddingOverride">
                <thead>
                  <tr>
                    <th>BAY</th>
                    <th>BIN</th>
                    <th>Part # <span className="requiredField">*</span></th>
                    <th>Description</th>
                    <th>Lot</th>
                    <th>UoM</th>
                    <th>Qty <span className="requiredField">*</span></th>
                    <th>Exp</th>
                    <th>PO</th>
                    <th>Transfer Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.pagedList && this.state.pagedList.list && this.state.pagedList.list.length > 0 ? (
                    this.state.pagedList.list.map((item, index) => (
                      <tr
                        key={`bayBin-${index}`}
                        id={`row-${index}`}
                        ref={el => (this.itemRefs[index] = el)}
                        className={classnames({ "cycleCountSelectedRow": index === selectedIndex }, "tabable")}
                        onClick={() => this.setOnclickFocus(index)}
                        tabIndex="0"
                      >
                        <Fragment>
                          <td>{item.bay}</td>
                          <td>{item.bin}</td>
                          <td style={{ width: "244px" }}
                            tabIndex="1">
                            {index === selectedIndex ? (
                              <ProductPartTypeahead
                                url={constant.url.ProductPartTypeahead}
                                placeholder={"Type Product Sku or Part #"}
                                onChange={this.onTypeAheadChange}
                                index={index}
                                id={`pnp-${index}`}
                                selectedOption={item.content}
                                onFocus={() => this.setState({ datePickerFocused: false })}
                              />
                            ) : (
                                <span>{item.content ? item.content.label : ""}</span>
                              )}
                          </td>
                          <td style={{ width: "30%" }}>{item.description || ""}</td>
                          <td tabIndex="2">
                            <Input type="text" name="lotNumber"
                              value={item.lotNumber ||""}
                              maxLength="50"
                              id={`ltn-${index}`}
                              disabled={index !== selectedIndex}
                              onFocus={() => this.setState({ typeaheadFocused: false,  datePickerFocused: false })}
                              onChange={(e) => this.onInputChange(e, index, "lotNumber")}
                              placeholder="Lot Number"
                            />
                          </td>
                          <td>{item.unitOfMeasurement}</td>
                          <td tabIndex="3">
                            {item.isProductContent
                              ? <Input
                                type="number"
                                name="productQuantity"
                                id={`pdq-${index}`}
                                value={item.productQuantity || ""}
                                placeholder="Quantity"
                                onChange={(e) => this.onInputChange(e, index, "productQuantity")}
                                onFocus={() => this.setState({ typeaheadFocused: false,  datePickerFocused: false })}
                                disabled={index !== selectedIndex || (!item.productSku && !item.partNumber)} />
                              : <Input
                                step="0.01"
                                name="partQuantity"
                                type="number"
                                id={`ptq-${index}`}
                                placeholder="Quantity"
                                value={item.partQuantity || ""}
                                onChange={(e) => this.onInputChange(e, index, "partQuantity")}
                                onFocus={() => this.setState({ typeaheadFocused: false,   datePickerFocused: false })}
                                disabled={index !== selectedIndex || (!item.productSku && !item.partNumber)} />
                            }
                          </td>
                          <td tabIndex="4">
                            <DatePicker
                              selected={item.expirationDate}
                              id={`exd-${index}`}
                              className="form-control pageTitleItem float-right mr-2"
                              placeholderText="Select expiration date"
                              onChange={(e) => this.onDateChange(e, index, "expirationDate")}
                              disabled={index !== selectedIndex}
                              onFocus={() => this.setState({ typeaheadFocused: false,   datePickerFocused: true })}
                              onFocusOut={() => this.setState({ datePickerFocused: false })}
                              ref={(ex) => { this.datePickerRef[index] = ex }}
                            />
                          </td>
                          <td tabIndex="5">
                            <Input
                              type="text"
                              name="poNumber"
                              maxLength="30"
                              id={`pon-${index}`}
                              value={item.poNumber || ""}
                              placeholder="PO Number"
                              onFocus={() => this.setState({ datePickerFocused: false })}
                              disabled={index !== selectedIndex} onChange={(e) => this.onInputChange(e, index, "poNumber")} />
                          </td>
                          <td tabIndex="6">
                            <DatePicker
                              selected={item.transferDate}
                              id={`tnd-${index}`}
                              className="form-control pageTitleItem float-right mr-2"
                              placeholderText="Select transfer date"
                              onChange={(e) => this.onDateChange(e, index, "transferDate")}
                              disabled={index !== selectedIndex}
                              onFocus={() => this.setState({ datePickerFocused: true })}
                              onFocusOut={() => this.setState({ datePickerFocused: false })}
                              ref={(ex) => { this.datePickerRef[index] = ex }}
                            />
                          </td>
                          <td tabIndex="7">
                            <ButtonGroup>
                              {index === selectedIndex &&
                                <Button className="buttonGroupSpacing cbdmdPrimaryOutline"
                                  onClick={() => this.onSave(index)}
                                  id={`sve-${index}`}
                                >
                                  <FontAwesomeIcon icon="save" />
                                </Button>
                              }
                              <Button className="buttonGroupSpacing cbdmdPrimary" title="Insert new row"
                                onClick={() => this.addNewRow(index, true)} id={`new-${index}`}
                                onFocus={()=>this.resolveTabEvent(index)}
                              >
                                <FontAwesomeIcon icon="plus" />
                              </Button>
                            </ButtonGroup>
                          </td>
                        </Fragment>
                      </tr>
                    ))) : null}
                </tbody>
              </Table>
            </Col>
          </Row>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InventoryCycleCount.js